// extracted by mini-css-extract-plugin
module.exports = {"root":"Modal_root__4PN6b","modalStart":"Modal_modalStart__2vI1h","exiting":"Modal_exiting__2cmh0"};